import { mergeClassName as e } from "../../utils/data.js";
import { Card as t } from "../Card/Card.js";
import { zonedDayString as n } from "../../utils/dates.js";
import r from "./Calendar.module.js";
import { CalendarFooter as i } from "./CalendarFooter.js";
import { DayCalendar as a } from "./DayCalendar.js";
import { MonthCalendar as ee } from "./MonthCalendar.js";
import { CUSTOM_PRESET_ID as o, datePickerPresetsDefault as s, dateRangePickerPresetsDefault as c } from "./presets.js";
import { PresetsSidebar as te } from "./PresetsSidebar.js";
import { useCallback as l, useEffect as ne, useMemo as u, useRef as d, useState as f } from "react";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
//#region lib/components/DatePicker/Calendar.tsx
function h(e) {
	return e !== void 0 && !(e instanceof Date);
}
function re(e, t) {
	return t === "single" ? e instanceof Date ? String(e.getTime()) : "" : h(e) ? `${e.from ? String(e.from.getTime()) : ""}-${e.to ? String(e.to.getTime()) : ""}` : "";
}
function g(e, t) {
	if (t === "single") {
		let t = e instanceof Date ? new Date(e) : void 0;
		return t && !Number.isNaN(t.getTime()) ? t : void 0;
	}
	if (h(e)) return {
		from: e.from ? new Date(e.from) : void 0,
		to: e.to ? new Date(e.to) : void 0
	};
}
function ie(e) {
	if (e) return {
		from: e.from,
		to: e.to
	};
}
function _(e, t, r) {
	return !e || !t ? !1 : n(e, r) === n(t, r);
}
function v(e) {
	return typeof e == "object" && !(e instanceof Date) && "before" in e && !("after" in e);
}
function y({ disabledDates: e, startMonth: t }) {
	let n = e === void 0 ? [] : [e].flat(), r = t;
	for (let e of n) v(e) && (!r || e.before > r) && (r = e.before);
	return r;
}
function b(e, t, n, r) {
	if (e.id === "custom") return !1;
	if ("getDate" in e) return _(e.getDate(n, { minDate: r }), t instanceof Date ? t : void 0, n);
	if (!h(t)) return !1;
	let i = e.getRange(n, { minDate: r });
	return _(i.from, t.from, n) && _(i.to, t.to, n);
}
function x(e, t) {
	if (t === "single" && e instanceof Date) return e;
	if (h(e) && e.from) return e.from;
}
function S(e, t, n, r) {
	return t ? t.find((t) => b(t, e, n, r))?.id ?? "custom" : o;
}
function C(n) {
	let { mode: _, value: v, defaultValue: b, onChange: C, numberOfMonths: w = n.mode === "range" ? 2 : 1, presets: T, presetsOrientation: E = "right", picker: D = "days", showFooter: O = !0, onApply: k, onCancel: A, className: j, cardProps: M, ...N } = n, P;
	T === !0 ? P = _ === "single" ? s : c : Array.isArray(T) && (P = T);
	let { timeZone: F } = N, I = v !== void 0, L = y(N)?.getTime(), R = u(() => L === void 0 ? void 0 : new Date(L), [L]), [ae, z] = f(() => g(b, _)), B = I ? v : ae, [V, H] = f(() => g(B, _)), [U, W] = f(D), [G, K] = f(() => x(B, _) ?? /* @__PURE__ */ new Date()), [q, J] = f(() => S(B, P, F, R)), Y = d(B);
	Y.current = B;
	let oe = re(B, _);
	ne(() => {
		let e = Y.current;
		H(g(e, _));
		let t = x(e, _);
		t && K(t), P && J(S(e, P, F, R));
	}, [
		oe,
		R,
		_,
		P,
		F
	]);
	let X = l((e) => {
		H(e), O || (I || z(e), C?.(e));
	}, [
		I,
		C,
		O
	]), se = l((e) => {
		if (J(e.id), e.id === "custom") W("days");
		else {
			if ("getDate" in e) {
				let t = e.getDate(F, { minDate: R });
				X(t), K(t);
			} else {
				let t = e.getRange(F, { minDate: R });
				X(t), t.from && K(t.from);
			}
			W("days");
		}
	}, [
		R,
		F,
		X
	]), ce = l(() => {
		I || z(V), C?.(V), k?.(V);
	}, [
		V,
		I,
		k,
		C
	]), Z = l(() => {
		H(g(B, _)), A?.();
	}, [
		B,
		_,
		A
	]), Q = P ? /* @__PURE__ */ p(te, {
		presets: P,
		activePresetId: q,
		onSelect: se,
		className: E === "left" ? r.sidebarLeft : r.sidebarRight
	}) : void 0, $ = () => {
		W("months");
	}, le = () => U === "months" ? /* @__PURE__ */ p(ee, {
		month: G,
		onMonthChange: K,
		selectedMonth: _ === "single" && V instanceof Date ? V : void 0,
		onSelectMonth: (e, t) => {
			K(new Date(t, e, 1)), W("days");
		}
	}) : _ === "single" ? /* @__PURE__ */ p(a, {
		mode: "single",
		selected: V instanceof Date ? V : void 0,
		numberOfMonths: w,
		month: G,
		onMonthChange: K,
		onCaptionClick: $,
		onSelect: (e) => {
			X(e instanceof Date ? e : void 0), J(o);
		},
		constraints: N
	}) : /* @__PURE__ */ p(a, {
		mode: "range",
		selected: ie(h(V) ? V : void 0),
		numberOfMonths: w,
		month: G,
		onMonthChange: K,
		onCaptionClick: $,
		onSelect: (e) => {
			!e || e instanceof Date || (X({
				from: e.from,
				to: e.to
			}), J(o));
		},
		constraints: N
	});
	return /* @__PURE__ */ m(t, {
		padding: 0,
		spacing: 0,
		radius: 2,
		...M,
		className: e(r.panel, P && r.panelWithSidebar, j, M?.className),
		children: [
			E === "left" && Q,
			/* @__PURE__ */ m("div", {
				className: r.panelBody,
				children: [/* @__PURE__ */ p("div", {
					className: r.calendarContent,
					children: le()
				}), O && /* @__PURE__ */ p(i, {
					onCancel: Z,
					onApply: ce
				})]
			}),
			E === "right" && Q
		]
	});
}
//#endregion
export { C as Calendar };
